<app-login-register-wrapper>
  <form
    [formGroup]="registerForm"
    (ngSubmit)="onSubmit()"
    class="login-form"
    *ngIf="registerForm"
  >
    <img class="emblem" src="/assets/img/img-login.png" alt="city-emblem"/>
    <div class="input-row">
      <input
        type="text"
        formControlName="merchantId"
        class="input"
        name="merchant-number"
        id="merchant-number"
        [class.error]="registerForm.errors && registerForm.errors.conflict"
        [placeholder]="'login.form.placeholder.card' | translate"
      />
    </div>
    <div class="input-row">
      <input
        type="text"
        formControlName="email"
        class="input"
        name="merchant-email"
        id="merchant-email"
        [class.error]="registerForm.errors && registerForm.errors.conflict"
        [placeholder]="'login.form.placeholder.email' | translate"
      />
    </div>
    <div class="input-row">
      <input
        type="password"
        formControlName="newPassword"
        class="input"
        [class.error]="
          registerForm.get('newPassword').dirty &&
          registerForm.get('newPassword').errors && (registerForm.get('newPassword').errors.tooShort || registerForm.get('newPassword').errors.tooLong || registerForm.get('newPassword').errors.insecure) ||
          registerForm.errors && registerForm.errors.notMatching
        "
        [placeholder]="'login.form.placeholder.new-pin' | translate"
      />
    </div>
    <div class="input-row with-caption">
      <input
        type="password"
        formControlName="newPasswordRepeat"
        class="input"
        [class.error]="registerForm.errors && registerForm.errors.notMatching"
        [placeholder]="'login.form.placeholder.repeat-new-pin' | translate"
      />
      <small (click)="onResetForm()">
        {{ "login.form.placeholder.not-your-card" | translate }}
      </small>
    </div>

    <div class="input-row" *ngIf="registerForm.valid">
      <button type="submit" class="btn" [disabled]="!registerForm.valid">
        <span>
          {{ "login.form.buttons.register" | translate }}
        </span>
      </button>
    </div>

    <ng-container *ngIf="registerForm.get('newPassword').errors">
      <div class="input-row password-security">
        <app-password-security
          *ngIf="registerForm.get('newPassword').value"
          [password]="registerForm.get('newPassword').value"
        ></app-password-security>
      </div>
    </ng-container>

    <div class="error-description">
      <div class="caption" *ngIf="registerForm">
        <ng-container
          *ngIf="registerForm.dirty && registerForm.get('newPassword').errors; else pinValid"
        >
          <small *ngIf="registerForm.get('newPassword').dirty && registerForm.get('newPassword').errors.tooShort">
            {{ 'login.form.errors.tooShort' | translate }}
          </small>
          <small *ngIf="registerForm.get('newPassword').dirty && registerForm.get('newPassword').errors.tooLong">
            {{ 'login.form.errors.tooLong' | translate }}
          </small>
          <small *ngIf="registerForm.get('newPassword').dirty && registerForm.get('newPassword').errors.insecure">
            {{ 'login.form.errors.insecure' | translate }}
          </small>
        </ng-container>
        <ng-template #pinValid>
          <small *ngIf="registerForm.errors">
            {{
              "login.form.errors." + (registerForm.errors | keyvalue)[0].key
                | translate
            }}
          </small>
        </ng-template>
      </div>
    </div>
  </form>
</app-login-register-wrapper>
